import { render } from "./CommunitySideNav.vue.js?vue&type=template&id=85088db2&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CommunitySideNav.vue?vue&type=template&id=85088db2&scoped=true"
import script from "./CommunitySideNav.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CommunitySideNav.vue?vue&type=script&lang=js"
export * from "./CommunitySideNav.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CommunitySideNav.vue?vue&type=script&lang=js"

import "./CommunitySideNav.vue.scss?vue&type=style&index=0&id=85088db2&scoped=true&lang=scss!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CommunitySideNav.vue?vue&type=style&index=0&id=85088db2&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85088db2"],['__file',"src/Web/scripts/components/side-nav/CommunitySideNav.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "85088db2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('85088db2', __exports__)) {
    api.reload('85088db2', __exports__)
  }
  
  module.hot.accept("./CommunitySideNav.vue.js?vue&type=template&id=85088db2&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CommunitySideNav.vue?vue&type=template&id=85088db2&scoped=true", () => {
    api.rerender('85088db2', render)
  })

}


export default __exports__